<div class="d-flex flex-column main-box justify-content-center align-items-center">
    <div class="text-container"> Are you sure you want to update the permissions of this user ?</div>
    <div class="btn-container">
        <div class="btns"><button class="dp-destructive-btn" (click)="onClose('Yes')">Yes</button></div>
        <div class="btns"><button class="dp-secondary-btn" (click)="onClose('No')">No</button></div>       
    </div>
</div>